﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Constraint } from "@models/configurators/output-fields/cad/mates/constraint";
import { eOutputFieldType } from "@models/enums";
import { IMate } from "@models/entity-models";
import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@Kbo(CToken.Mate)
export class Mate extends Constraint implements IMate {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public parentId: string;
    public referenceComponentName: string;
    public referenceComponentId: string;
    public existingEntity: string;
    public dynamicEntity: string;
    public aligned: boolean;
}
